/**
 * @generated SignedSource<<ec65ad8a447b36fcdfe49ce1c6c1ea05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NumberTaskUnit = "CURRENCY" | "CUSTOM";
import { FragmentRefs } from "relay-runtime";
export type TaskExecutionNumberComponent_TaskExecutionNumber$data = {
  readonly id: string;
  readonly numberValue: number | null;
  readonly task: {
    readonly id: string;
    readonly unit: NumberTaskUnit;
  };
  readonly " $fragmentType": "TaskExecutionNumberComponent_TaskExecutionNumber";
};
export type TaskExecutionNumberComponent_TaskExecutionNumber$key = {
  readonly " $data"?: TaskExecutionNumberComponent_TaskExecutionNumber$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskExecutionNumberComponent_TaskExecutionNumber">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskExecutionNumberComponent_TaskExecutionNumber",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskNumber",
      "kind": "LinkedField",
      "name": "task",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberValue",
      "storageKey": null
    }
  ],
  "type": "TaskExecutionNumber",
  "abstractKey": null
};
})();

(node as any).hash = "c6209dbce4b744258dd598e28933fc7c";

export default node;
